/** Right panel width – consistent across Registration, Pre-Consultation, Patient Visit, Prescription */
export const RIGHT_PANEL_WIDTH = 480;
export const RIGHT_PANEL_WIDTH_XS = '100%';
